import { staffPharmacyCode, staffPharmacyName } from './lib/pwa';

/** Branded launch screen — shown while the app resolves the session and
 * loads its first feed. Falls back to DutiLyne branding before a staff
 * member has ever opened their pharmacy's link. */
export default function StaffAppSplash({ fading = false }) {
  const code = staffPharmacyCode();
  const name = staffPharmacyName();
  const icon = code ? `/api/staff-app/manifest/${encodeURIComponent(code)}/icon/192.png` : '/staff-icon-192.png';

  return (
    <div data-testid="staff-app-splash"
      className={`fixed inset-0 z-50 flex flex-col items-center justify-center gap-4 bg-background transition-opacity duration-500 ${fading ? 'opacity-0' : 'opacity-100'}`}>
      <img src={icon} alt="" className="h-20 w-20 rounded-[22px] shadow-lg object-contain bg-white staff-splash-mark"
        onError={(e) => { e.currentTarget.src = '/staff-icon-192.png'; }} />
      <div className="text-center px-8">
        <p className="text-lg font-bold tracking-tight" data-testid="staff-app-splash-name">{name || 'Staff Companion'}</p>
        <p className="text-xs text-muted-foreground mt-1">{name ? 'Staff Companion' : 'Chats, orders and alerts, in your pocket'}</p>
      </div>
      <div className="w-28 h-1 rounded-full bg-muted overflow-hidden" aria-hidden="true">
        <div className="h-full w-1/2 rounded-full bg-primary staff-splash-bar" />
      </div>
      <p className="absolute bottom-8 text-[11px] text-muted-foreground/70">Powered by DutiLyne</p>
    </div>
  );
}
